<template>
	<cleave class="cbs-masked-input" v-bind="$attrs" v-on="$listeners" :value="value" :options="options" @input="val => $emit('input', val)" />
</template>

<script>
import Cleave from "vue-cleave-component";

export default {
	name: "CbsMaskedInput",
	inheritAttrs: false,
	components: {
		Cleave
	},
	props: {
		value: {
			required: true
		},
		dataType: {
			type: String,
			validator: prop => ["int", "float", "text"].includes(prop),
			default: "text"
		},
		userSetting: {
			type: Object
		}
	},
	computed: {
		maxLength() {
			const inputMaxLengthConfig = {
				int: 12,
				float: 15,
				text: 255
			};

			return inputMaxLengthConfig[this.dataType] || null;
		}
	},
	watch: {
		userSetting() {
			this.setOptionsByUserSetting();
		}
	},
	data() {
		return {
			options: this.$attrs.options
		};
	},
	methods: {
		setOptionsByUserSetting() {
			if (this.userSetting) {
				const maskedSettings = {
					numeral: true,
					noImmediatePrefix: true,
					numeralIntegerScale: this.maxLength,
					numeralDecimalScale: 2,
					delimiter: ',',
					numeralDecimalMark: '.',
					// numeralDecimalScale: this.userSetting.hasOwnProperty("number_format_decimals") ? Number(this.userSetting.number_format_decimals) : 0,
					// delimiter: this.userSetting.hasOwnProperty("number_format_separator") ? this.userSetting.number_format_separator : this.userSetting.locale === "vn" ? "." : ",",
					// numeralDecimalMark: this.userSetting.hasOwnProperty("number_format_decimalpoint") ? this.userSetting.number_format_decimalpoint : this.userSetting.locale === "vn" ? "," : "."
				};

				this.options = Object.assign({}, this.$attrs.options, maskedSettings);
			}
		}
	},
	created() {
		this.setOptionsByUserSetting();
	}
};
</script>
